import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-menu-icon',
  templateUrl: './text-menu.component.html'
})
export class TextMenuComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
